import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import ReCAPTCHA from 'react-google-recaptcha'
import { useLocation } from 'react-router-dom';

const recaptchaSiteKey = process.env.TBX_RECAPTCHA_KEY || (window.AppENV && window.AppENV.RECAPTCHA_KEY);
const recaptchaRef = React.createRef();
const plans = ["DAILY", "WEEKLY", "MONTHLYN"]

const onSubmit = async (e, onClick, valNumber, activateRecaptcha, loadingOn, loadingOff,
  checkboxText, checkboxValue, setShowCheckError, showSubscriptionPlan, subscriptionPlan, setSubscriptionPlanErr) => {
  e.preventDefault();
  if (setShowCheckError) setShowCheckError(false)
  if (setSubscriptionPlanErr) setSubscriptionPlanErr(false)

  if (!plans.includes(subscriptionPlan) && showSubscriptionPlan) {
    setSubscriptionPlanErr(true)
    return
  }

  if (checkboxText != null && !checkboxValue) {
    setShowCheckError(true);
    return;
  }

  let token;

  if (activateRecaptcha === 'true') {
    loadingOn();
    token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    loadingOff();

    onClick({ valNumber, token });
  } else {
    onClick(valNumber);
  }
};

const FormRequest = ({ header, subheader, placeholder, btncolor, _onChange,
  _onClick, btntext, extraActiontext, _onClickExtraAction, valNumber,
  pinForAuthorizeError, pattern, activateRecaptcha, dangerAlert, loadingOn,
  loadingOff, checkboxText, showBackButton, showSubscriptionPlan, subscriptionPlan: plan, _onChangePlan }) => {
  const [checkState, setCheckState] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState(undefined);
  const [showCheckError, setShowCheckError] = useState(false);
  const [subscriptionPlanErr, setSubscriptionPlanErr] = useState(false);
  const search = new URLSearchParams(useLocation().search);

  useEffect(() => {
    setCheckState(false);
    setShowCheckError(false);
  }, []);

  const onChangeSubscriptionPlan = (e) => {
    setSubscriptionPlanErr(false)
    setSubscriptionPlan(e.target.value);
    _onChangePlan(e)
  }

  return (
    <form onSubmit={(e) => {
      onSubmit(e, _onClick, valNumber, activateRecaptcha,
        loadingOn, loadingOff, checkboxText,
        checkState, setShowCheckError, showSubscriptionPlan, subscriptionPlan, setSubscriptionPlanErr);
    }}
      style={{ maxWidth: '400px', margin: 'auto' }}
      className='bitel-form'
    >
      <p style={{ marginBottom: '24px', marginTop: '14px' }}><span style={{ fontWeight: '500' }}>{header}</span></p>
      <p><small>{subheader}</small></p>
      <div style={{ backgroundColor: '#EEEEE5', padding: '20px', borderRadius: '4px', width: '100%', marginBottom: '24px' }} >
        <input
          type="tel"
          style={{ borderColor: pinForAuthorizeError.message ? '#dc3545' : '#ced4da', fontWeight: '600' }}
          className="form-control block bitel-input"
          value={valNumber || ''}
          placeholder={placeholder}
          onChange={(e) => _onChange(e)}
          pattern={pattern}
        />
        {
          showSubscriptionPlan &&
          <select
            className="bitel-plan-select"
            aria-label=".form-select-lg example"
            style={{
              padding: '0px 20px',
              margin: '0',
              width: '100%',
              marginTop: '20px',
              height: '44px',
              border: '1px solid #ced4da',
              borderColor: subscriptionPlanErr ? '#dc3545' : '#ced4da'
            }}
            onChange={(e) => onChangeSubscriptionPlan(e)}
            value={subscriptionPlan}
          >
            <option hidden defaultValue="">Plan de subscripción</option>
            <option value="MONTHLYN">Subscripción mensual</option>
          </select>
        }
        {
          pinForAuthorizeError
          && (
            <div className="noti-feedback">
              {pinForAuthorizeError.message}
            </div>
          )
        }
        {subscriptionPlanErr ?
          <label className="noti-feedback">Debes seleccionar uno de los planes</label>
          : ''
        }
      </div>
      {checkboxText ?
        <div className="form-check checkContainer" style={{ marginBottom: '20px' }}>
          <input
            name="tyc"
            className="form-check-input"
            type="checkbox"
            id="tyc"
            checked={checkState}
            onChange={(e) => setCheckState(!checkState)}
          />
          Acepta los
          <a
            target='_blank'
            rel="noopener noreferrer"
            href={`https://play.bitel.com.pe/wp-content/uploads/2024/09/1.-TERMINOS-Y-CONDICIONES-Paramount-vf.pdf`}
            className="form-check-label"
            htmlFor="tyc"
          >
            <span style={{ fontWeight: 'bold' }}>{' ' + checkboxText}</span>
          </a>
          {showCheckError ?
            <label className="noti-feedback">Debes aceptar los Términos y Condiciones</label>
            : ''
          }
        </div>
        : ''
      }
      <Button
        color={btncolor}
        block
        onClick={(e) => {
          onSubmit(e, _onClick, valNumber, activateRecaptcha, loadingOn,
            loadingOff, checkboxText, checkState, setShowCheckError, showSubscriptionPlan, subscriptionPlan, setSubscriptionPlanErr);
        }}
      >

        <span style={{ fontWeight: '600' }}>{btntext}</span>
      </Button>
      {
        showBackButton &&
        (<Button
          color="secondary"
          block
          onClick={(e) => { _onClickExtraAction('renew'); }}
        >
          <span style={{ fontWeight: '600' }}>REGRESAR</span>
        </Button>)
      }
      {
        extraActiontext
        && (<Button
          color="link"
          onClick={() => _onClickExtraAction('renew')}
        >
          {extraActiontext}
        </Button>)
      }
      {
        activateRecaptcha === 'true'
        && (
          <div className="recaptcha-div">
            <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey={recaptchaSiteKey}
            />
          </div>
        )
      }
    </form>
  )
};

FormRequest.defaultProps = {
  extraActiontext: null,
  _onClickExtraAction: () => { },
  valNumber: [''],
  pinForAuthorizeError: null,
  activateRecaptcha: 'false'
};

FormRequest.propTypes = {
  _onChange: PropTypes.func.isRequired,
  _onClick: PropTypes.func.isRequired,
  _onClickExtraAction: PropTypes.func,
  header: PropTypes.string.isRequired,
  subheader: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  btncolor: PropTypes.string.isRequired,
  btntext: PropTypes.string.isRequired,
  extraActiontext: PropTypes.string,
  activateRecaptcha: PropTypes.string,
  valNumber: PropTypes.array,
  pinForAuthorizeError: PropTypes.object,
  showBackButton: PropTypes.bool
};

export default FormRequest;
